<template>
  <div ref="Drawer">
    <a-drawer v-model:open="open" class="custom-class" root-class-name="root-class-name" :closable="false"
      placement="right" :width="'628px'" @after-open-change="afterOpenChange" @close="cancel"
      wrapClassName="drawer-style" :getContainer="() => Drawer">
      <template v-slot:title>
        <div>
          <MyIcon type="icon-renyuanguanliicon" style="font-size: 25px; vertical-align: top" />

          <span class="ml10 first_title">人员管理/</span><span>{{ drawerTitle }}</span>
        </div>
      </template>
      <template #extra>
        <div class="back" @click="closeOpen">
          <a-button type="primary">
            <i class="iconfont icon-fanhuiicon mr5"></i>返回
          </a-button>
        </div>
      </template>
      <template v-if="drawerTitle != '详情'" #footer>
        <div class="botm">
          <a-button type="primary" ghost class="ml10" @click="cancel">取消</a-button>
          <a-button type="primary" class="ml10" @click="confirm">确定</a-button>
        </div>
      </template>

      <a-form ref="formRef" :model="form" name="basic" :rules="rules" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }">
        <a-form-item v-if="!store.roles.includes('carEnterprise')" label="企业名称" name="deptName">
          <a-select @change="selectChange" v-model:value="form.deptName" placeholder="请输入">
            <a-select-option v-for="item in selectData" :key="item.id" :value="item.name">{{ item.name
              }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="姓名" name="name">
          <a-input v-model:value="form.name" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="性别" name="gender">
          <a-radio-group v-model:value="form.gender" name="sexy">
            <a-radio :value="0">女</a-radio>
            <a-radio :value="1">男</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="类型" name="personType">
          <a-checkbox-group @change="groupChange" v-model:value="form.personType" name="personType"
            :options="typeOptions" />
        </a-form-item>
        <a-form-item label="出生年月" name="birthDate">
          <a-month-picker style="width: 100%" v-model:value="form.birthDate" format="YYYY-MM" valueFormat="YYYY-MM"
            :disabled-date="disabledDate" placeholder="请输入出生年月" />
        </a-form-item>
        <a-form-item label="证件类型及证件号" name="certificateNum">
          <a-input v-model:value="form.certificateNum">
            <template #addonBefore>
              <a-select v-model:value="form.certificateType" style="width: 90px">
                <a-select-option value="idCard">身份证</a-select-option>
              </a-select>
            </template>
          </a-input>
        </a-form-item>
        <a-form-item label="电话号码" name="phoneNum">
          <a-input v-model:value="form.phoneNum" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="驾驶证号" :name="form.personType[0] === 'driver' || form.personType[1] === 'driver'
      ? 'driverNum'
      : ''
      ">
          <a-input v-model:value="form.driverNum" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="培训时间" name="trainDate">
          <a-date-picker v-model:value="form.trainDate" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
            :disabled-date="disabledDate" style="width: 100%" :auto-complete="'off'" />
        </a-form-item>
        <a-form-item label="密码" name="passwd">
          <password-input v-model:value="form.passwd" @focus="inputPassFocus" placeholder="请输入密码" @strengthChange="handleStrengthChange"/>
        </a-form-item>
        <a-form-item label="确认密码" name="repassword">
          <password-input v-model:value="form.repassword" @focus="inputRepassFocus" placeholder="请重新输入密码" @strengthChange="handleStrengthChange"/>
        </a-form-item>
<!--        <a-form-item label="密码" name="passwd">-->
<!--          <a-input-password @focus="inputPassFocus" :visibility-toggle="drawerTitle === '编辑' ? false : true"-->
<!--            v-model:value="form.passwd" placeholder="请输入" />-->
<!--        </a-form-item>-->
<!--        <a-form-item label="确认密码" name="repassword">-->
<!--          <a-input-password @focus="inputRepassFocus" :visibility-toggle="drawerTitle === '编辑' ? false : true"-->
<!--            v-model:value="form.repassword" placeholder="请输入" />-->
<!--        </a-form-item>-->
        <a-form-item label="状态" name="status">
          <a-radio-group v-model:value="status" @change="radioChange" name="status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">禁用</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-drawer>
  </div>
</template>
<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  defineExpose,
  toRaw,
  defineProps,
  defineEmits,
  watch,
} from "vue";
import { cloneDeep } from "lodash-es";
import { message } from "ant-design-vue";
import {
  detailById,
  checkIdCardNumRepeat,
  checkPhoneNumRepeat,
} from "@/api/securityUser/index.js";
import moment from "moment";
import { getList } from "@/api/enterprise/index.js";
import PasswordInput from '@/components/PasswordInput';

import useUserStore from "@/store/modules/user";

const store = useUserStore();

const Drawer = ref();
const props = defineProps({
  drawerTitle: {
    type: String,
    default: () => "",
  },
  data: {
    type: Object,
    default: () => { },
  },
});

const checkAge = async (_rule, value) => {
  if (!value) {
    return Promise.reject("请输入电话号码");
  } else {
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!reg.test(value)) {
      return Promise.reject("请输入正确的电话号码");
    } else {
      return Promise.resolve();
    }
  }
};

const handleStrengthChange = (strength) => {
  console.log('密码强度变化:', strength);
  // 可以根据强度做额外处理
};

const checkCardNo = async (_rule, value) => {
  if (!value) {
    return Promise.reject("请输入证件号码");
  } else {
    const reg =
      /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
    if (!reg.test(value)) {
      return Promise.reject("请输入正确的证件号码");
    } else {
      return Promise.resolve();
    }
  }
};
const checkRePsw = async (_rule, value) => {
  console.log(_rule, form.value);
  if (!value) {
    return Promise.reject("请再次输入密码");
  } else {
    if (form.value.passwd != value) {
      return Promise.reject("密码不一致，请检查");
    } else {
      return Promise.resolve();
    }
  }
};

const typeOptions = [
  { label: "驾驶员", value: "driver" },
  { label: "安全员", value: "security" },
];

const open = ref(false);
const formRef = ref();
const form = ref({
  deptId: "",
  deptName: undefined,
  name: "",
  gender: 1,
  personType: [],
  phoneNum: "",
  birthDate: "",
  certificateType: "idCard",
  certificateNum: "",
  driverNum: "",
  trainDate: "",
  passwd: "",
  repassword: "",
  status: 1,
});

const reset = () => {
  (form.value = {
    deptId: "",
    deptName: undefined,
    name: "",
    gender: 1,
    personType: [],
    phoneNum: "",
    birthDate: "",
    certificateType: "idCard",
    certificateNum: "",
    driverNum: "",
    trainDate: "",
    passwd: "",
    repassword: "",
    status: 1,
  }),
    (status.value = 1);
};
const cardType = ref(1);

const rules = {
  deptName: [
    { required: true, message: "企业名称不能为空", trigger: "change" },
  ],
  name: [{ required: true, message: "姓名不能为空", trigger: "change" }],
  gender: [{ required: true, message: "姓别不能为空", trigger: "change" }],
  personType: [{ required: true, message: "类型不能为空", trigger: "change" }],
  birthDate: [
    { required: true, message: "出生年月不能为空", trigger: "change" },
  ],
  phoneNum: [
    {
      required: true,
      trigger: "blur",
      validator: checkAge,
    },
  ],
  driverNum: [
    { required: true, message: "驾驶证号不能为空", trigger: "change" },
  ],
  certificateNum: [{ required: true, trigger: "blur", validator: checkCardNo }],
  trainDate: [
    { required: true, message: "培训时间不能为空", trigger: "change" },
  ],
  passwd: [
    { required: true, message: "密码不能为空", trigger: "blur" },
    { min: 6, max: 66, message: "长度在 6 个字符以上", trigger: "blur" },
  ],
  repassword: [{ required: true, trigger: "blur", validator: checkRePsw }],
  status: [{ required: true, message: "状态不能为空", trigger: "change" }],
};

watch(
  () => props.data,
  (val) => { },
  { deep: true }
);

const disabledDate = (current) => {
  // Can not select days before today and today
  return current && current > moment();
};

const selectData = ref([]);
const getSelectData = () => {
  const data = {
    pageIndex: 1,
    pageSize: 10000,
    conditionMap: {
      name: "",
      corporationName: "",
      id: store.deptId,
    },
  };
  getList(data).then((res) => {
    console.log(res);
    if (res.code === 200) {
      selectData.value = res.data.records;
    }
  });
};

const selectChange = (value) => {
  console.log(value);
  console.log(selectData.value);
  let res = selectData.value.find((item) => item.name === value);
  form.value.deptId = res.id;
  console.log(form.value);
};

const status = ref(0);
const radioChange = (e) => {
  console.log(e.target.value);
  form.value.status = e.target.value;
};

const inputPassFocus = (e) => {
  console.log(e.target.value);
  if (props.drawerTitle === "编辑") {
    form.value.passwd = "";
  }
};

const inputRepassFocus = (e) => {
  console.log(e.target.value);
  if (props.drawerTitle === "编辑") {
    form.value.repassword = "";
  }
};
const groupChange = (e) => {
  console.log(e.includes("driver"));
  if (!e.includes("driver")) {
    formRef.value.clearValidate("driverNum")
  }
}


const afterOpenChange = (bool) => {
  console.log("open", bool);
};

const editId = ref(null);

const showDrawer = (data) => {
  open.value = true;
  reset();
  console.log(data);
  if (data) {
    editId.value = data.id;
    console.log(data);
    detailById(data.id).then((res) => {
      console.log(res, '11111111111111111111111');
      if (res.code === 200) {
        res.data.personType = res.data.personType ? res.data.personType.split(",") : '';
        status.value = res.data.status;
        form.value = res.data;
        form.value.repassword = res.data.passwd;
        if (store.roles.includes("carEnterprise")) {
          form.value.deptName = res.data.deptName;
          form.value.deptId = res.data.deptId;
        }
      }
    });
  }
};
const closeOpen = () => {
  open.value = false;
  formRef.value.resetFields();
};

const emit = defineEmits(["drawerEvent"]);

// 保存
const confirm = () => {
  console.log("保存");
  //车企端"deptIdStr"
  console.log(store.roles, store.deptName);
  // if (store.roles.includes("carEnterprise")) {
  //   console.log(123);
  //   form.value.deptName = store.deptName;
  //   form.value.deptId = store.deptId;
  // }
  formRef.value
    .validate()
    .then(() => {
      console.log("values", form.value);
      const drawerValue = JSON.parse(JSON.stringify(form.value));

      checkIdCardNumRepeat(editId.value, drawerValue.certificateNum).then(
        (res) => {
          console.log(res);
          if (res.data) {
            message.error("身份证号重复，请重新填写");
          } else {
            checkPhoneNumRepeat(editId.value, drawerValue.phoneNum).then(
              (res) => {
                if (res.data) {
                  message.error("手机号重复，请重新填写");
                } else {
                  emit("drawerEvent", drawerValue);
                  open.value = false;
                }
              }
            );
          }
        }
      );

      console.log(123);
    })
    .catch((error) => {
      console.log("error", error);
    });
};
// 取消
const cancel = () => {
  console.log("取消");
  open.value = false;
  formRef.value.resetFields();
};

onMounted(() => {
  getSelectData();
});

// 使用 defineExpose 向外暴露指定的数据和方法
defineExpose({
  showDrawer,
});
</script>
<style lang="less" scoped>
.first_title {
  color: rgba(29, 33, 41, 0.7);
  font-weight: 600;
  font-size: 18px;
}

.botm {
  text-align: center;
}

.inp {
  width: 470px;
}

.col {
  display: flex;
  justify-content: right;
  align-items: center;
}

.add_text {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #186ff2;
}

/deep/.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background: #f2f4f7;
}

.left {
  text-align: left;
  align-items: flex-start;

  .ant-radio-group {
    width: 81%;
  }
}

/deep/ .ant-drawer .ant-drawer-footer {
  display: flex;
  justify-content: center;
  border-top: 0px;
  margin-bottom: 40px;
}

/deep/ .ant-drawer .ant-drawer-header {
  border-bottom: 0px;
}

.botm {
  display: flex;
  justify-content: space-between;
  width: 32%;
}

/deep/.ant-drawer-title {
  color: rgba(29, 33, 41, 1);
  font-weight: 600;
  font-size: 18px;
}
</style>
